import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import Model from "@ckeditor/ckeditor5-ui/src/model";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import FileDialogButtonView from '@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview';

import {
    addListToDropdown,
    createDropdown
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";

import SplitButtonView from "@ckeditor/ckeditor5-ui/src/dropdown/button/splitbuttonview";

import Icon from './../icons/icon_symbol_style.svg';
import iconStrikethrough from '@ckeditor/ckeditor5-basic-styles/theme/icons/strikethrough.svg';
import iconSubscript from '@ckeditor/ckeditor5-basic-styles/theme/icons/subscript.svg';
import iconSuperscript from '@ckeditor/ckeditor5-basic-styles/theme/icons/superscript.svg';
import iconUnderline from '@ckeditor/ckeditor5-basic-styles/theme/icons/underline.svg';
import iconSmallCaps from './../smallCaps/icons/smallcaps.svg';

export default class TextStylesDropDown extends Plugin {
    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("TextStylesDropDown", locale => {
            const dropdownView = createDropdown(locale, SplitButtonView);
            dropdownView.buttonView.actionView.set({
                withText: false,
                label: "Стили текста",
                icon: Icon,
                tooltip: true
            });
            dropdownView.class = 'comp_g';
            const items = new Collection();
            items.add({
                type: "button",
                model: new Model({
                    id: 'strikethrough',
                    withText: false,
                    icon: iconStrikethrough,
                    label: "Зачеркнутый",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'subscript',
                    withText: false,
                    icon: iconSubscript,
                    label: "Подстрочный",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'superscript',
                    withText: false,
                    label: "Надстрочный",
                    icon: iconSuperscript,
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'underline',
                    withText: false,
                    label: "Подчеркнутый",
                    icon: iconUnderline,
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'smallCaps',
                    withText: false,
                    label: "Заглавные",
                    icon: iconSmallCaps,
                    tooltip: true
                })
            });

            addListToDropdown(dropdownView, items);
            dropdownView.on('execute', (eventInfo) => {
                const {id, label} = eventInfo.source;
                editor.execute(id);
            });

            return dropdownView;
        });
    }
}